const { h, render, Component } = require('preact');
const FAQSearchContainer = require('../search/faq_search')
const FaqsContainer = require('../faq/faqs')
const SignInSignUp = require('./sign_in_sign_up')
const OtherIssues = require('./other_issues')
const Banner = require ('../../views/common/banner.js')
const MarketingBanner = require ('../../views/common/marketing-banner.js');
const Helper = require('../../../helper')

class LoggedOutLandingPage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
      let inbentaSessionToken = sessionStorage.getItem('inbentaSessionKey')
      if (!inbentaSessionToken || inbentaSessionToken === "null" || inbentaSessionToken === "undefined") {
          Helper.createSession();
      }
  }

  hideHeaderBannerIfPresent() {
    var headerBanner = document.getElementById("header-banner")
    if (headerBanner)
      headerBanner.setAttribute("style", "display:none")
  }



  render() {
    this.hideHeaderBannerIfPresent()
    return (
      <div className="twelve columns">
        <div className="page_header">
          <MarketingBanner />
          <Banner />
          <h2>{I18n.t('js.modules.web_2018.customer_support')}</h2>
        </div>
        <FAQSearchContainer/>
        <SignInSignUp />
        <FaqsContainer />
        <OtherIssues />
      </div>
    );
  }
}
module.exports = LoggedOutLandingPage
